<template>
  <div
    v-if="$can('read', 'current-plan')"
    :class="`${flexDirection === 'col' ? 'flex-col gap-4' : 'flex-row'} w-100 flex justify-between`">
    <CommonProgressBar
      :class="`${flexDirection === 'col' ? 'w-100' : !hideCta ? 'w-3/6' : 'w-10/12'}`"
      v-bind="progressBarProps"
      :trail-color="unlimited ? '#615DF44D' : null" />
    <UpgradePlanButton
      v-if="!hideCta"
      size="default"
      :label="buttonLabel"
      :class="`rounded-lg ${flexDirection === 'col' ? 'max-w-44' : ''}`" />
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { storeToRefs } from "pinia"
import CommonProgressBar from "@/components/Base/ProgressBar.vue"
import UpgradePlanButton from "@/components/UpgradePlan/UpgradePlanButton.vue"
import { useUserAccountsStore } from "../../stores/userAccounts"

const props = defineProps({
  flexDirection: {
    type: String,
    default: "row"
  },
  buttonLabel: {
    type: String,
    default: null
  },
  hideCta: {
    type: Boolean,
    default: false
  },
  unlimited: {
    type: Boolean,
    default: false
  }
})

const { userPlan, userAccount } = storeToRefs(useUserAccountsStore())

const { t } = useI18n()

const progressBarProps = computed(() => ({
  valueNow: userAccount.value?.totals?.qr || 0,
  valueMax: userPlan.value?.features?.limits?.qr || 0,
  caption: props.unlimited
    ? t("settings.billing.usage.links.unlimited.label")
    : t("navigation.usage.label", {
        current: userAccount.value?.totals?.qr || 0,
        total: userPlan.value?.features?.limits?.qr
      })
}))
</script>
